import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-localize-redux';
import { string, func } from 'prop-types';

import { logInAs, getUsers } from '../../../auth';
import { routes } from '../../../constants';
import { addErrorMessageAction, setTaskPending, setTaskFulfilled } from '../../../actions';

import styles from '../login.module.css';

const redirectBack = (referrer) => {
  window.location.href = referrer;
};

class InAppLogin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      users: []
    };

    this.login = this.login.bind(this);
  }

  componentDidMount() {
    this.props.dispatchSetTaskPending();

    getUsers().then((users) => {
      this.setState({ users });
    })
      .catch(this.props.dispatchAddErrorMessage)
      .finally(this.props.dispatchSetTaskFulfilled);
  }

  login(e, user) {
    e.preventDefault();

    this.props.dispatchSetTaskPending();

    logInAs(user).then(() => {
      redirectBack(this.props.referrer);
    })
      .catch(this.props.dispatchAddErrorMessage)
      .finally(this.props.dispatchSetTaskFulfilled);
  }

  render() {
    return (
      <div className={styles.container}>
        <h1 className={styles.heading}><Translate id="login.chooseUser" /></h1>
        <ul>
          {this.state.users.map((user) => (
            <li className={styles.li} key={user.externalId}>
              <a
                href={this.props.referrer || routes.index}
                className={`button ${styles.link}`}
                onClick={(e) => this.login(e, user)}
              >
                {user.commonName}
              </a>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

InAppLogin.propTypes = {
  referrer: string.isRequired,
  dispatchAddErrorMessage: func.isRequired,
  dispatchSetTaskPending: func.isRequired,
  dispatchSetTaskFulfilled: func.isRequired
};

const mapDispatchToProps = (dispatch) => ({
  dispatchAddErrorMessage: (err) => dispatch(addErrorMessageAction(err)),
  dispatchSetTaskPending: () => dispatch(setTaskPending()),
  dispatchSetTaskFulfilled: () => dispatch(setTaskFulfilled())
});

export default connect(null, mapDispatchToProps)(InAppLogin);
